import api from './api'

const mailTemplateCategoryService = {
  // Get all mail template categories
  async getMailTemplateCategories(params = {}) {
    try {
      params['_no_pagination_'] = 1
      const response = await api.get('/admin/mail-template-categories', { params })
      return response
    } catch (error) {
      console.error('Error fetching mail template categories:', error)
      throw error
    }
  },

  // Create new mail template category
  async createMailTemplateCategory(categoryData) {
    try {
      const response = await api.post('/admin/mail-template-categories', categoryData)
      return response
    } catch (error) {
      console.error('Error creating mail template category:', error)
      throw error
    }
  },

  // Update mail template category
  async updateMailTemplateCategory(id, categoryData) {
    try {
      const response = await api.put(`/admin/mail-template-categories/${id}`, categoryData)
      return response
    } catch (error) {
      console.error('Error updating mail template category:', error)
      throw error
    }
  },

  // Delete mail template category
  async deleteMailTemplateCategory(id) {
    try {
      const response = await api.delete(`/admin/mail-template-categories/${id}`)
      return response
    } catch (error) {
      console.error('Error deleting mail template category:', error)
      throw error
    }
  }
}

export default mailTemplateCategoryService 